// Shared utilities for tour management

export const TOUR_SKIPPED_KEY = 'stackguard_tours_skipped';

/**
 * Check if tours have been skipped
 */
export const isTourSkipped = () => {
  return localStorage.getItem(TOUR_SKIPPED_KEY) === 'true';
};

/**
 * Mark tours as skipped
 */
export const skipTours = () => {
  localStorage.setItem(TOUR_SKIPPED_KEY, 'true');
};

/**
 * Reset skip state (for testing or if user wants to re-enable tours)
 */
export const resetTourSkip = () => {
  localStorage.removeItem(TOUR_SKIPPED_KEY);
};

